export default __webpack_public_path__ + "static/poster-f25095ac0ce1189e93b1fd7e1657449e.png";